'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _canvasGauges = require('canvas-gauges');

var _canvasGauges2 = _interopRequireDefault(_canvasGauges);

var _tinycolor = require('tinycolor2');

var _tinycolor2 = _interopRequireDefault(_tinycolor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright © 2016-2018 The Thingsboard Authors
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed under the Apache License, Version 2.0 (the "License");
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * you may not use this file except in compliance with the License.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You may obtain a copy of the License at
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *     http://www.apache.org/licenses/LICENSE-2.0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Unless required by applicable law or agreed to in writing, software
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * distributed under the License is distributed on an "AS IS" BASIS,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * See the License for the specific language governing permissions and
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * limitations under the License.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


/* eslint-disable angular/angularelement */

var defaultDigitalGaugeOptions = Object.assign({}, _canvasGauges2.default.GenericOptions, {
    gaugeType: 'arc',
    gaugeWithScale: 0.75,
    dashThickness: 0,
    roundedLineCap: false,

    gaugeColor: '#777',
    levelColors: ['blue'],

    symbol: '',
    label: '',
    hideValue: false,
    hideMinMax: false,

    fontTitle: 'Roboto',

    fontValue: 'Roboto',

    fontMinMaxSize: 10,
    fontMinMaxStyle: 'normal',
    fontMinMaxWeight: '500',
    colorMinMax: '#eee',
    fontMinMax: 'Roboto',

    fontLabelSize: 8,
    fontLabelStyle: 'normal',
    fontLabelWeight: '500',
    colorLabel: '#eee',
    fontLabel: 'Roboto',

    neonGlowBrightness: 0,

    isMobile: false

});

var round = Math.round;

var CanvasDigitalGauge = function (_canvasGauges$BaseGau) {
    _inherits(CanvasDigitalGauge, _canvasGauges$BaseGau);

    function CanvasDigitalGauge(options) {
        _classCallCheck(this, CanvasDigitalGauge);

        _canvasGauges2.default.performance = window.performance; // eslint-disable-line no-undef, angular/window-service
        options = Object.assign({}, defaultDigitalGaugeOptions, options || {});

        var _this = _possibleConstructorReturn(this, (CanvasDigitalGauge.__proto__ || Object.getPrototypeOf(CanvasDigitalGauge)).call(this, CanvasDigitalGauge.configure(options)));

        _this.initValueClone();
        return _this;
    }

    _createClass(CanvasDigitalGauge, [{
        key: 'initValueClone',
        value: function initValueClone() {
            var canvas = this.canvas;
            this.elementValueClone = canvas.element.cloneNode(true);
            this.contextValueClone = this.elementValueClone.getContext('2d');
            this.elementValueClone.initialized = false;

            this.contextValueClone.translate(canvas.drawX, canvas.drawY);
            this.contextValueClone.save();

            this.elementProgressClone = canvas.element.cloneNode(true);
            this.contextProgressClone = this.elementProgressClone.getContext('2d');
            this.elementProgressClone.initialized = false;

            this.contextProgressClone.translate(canvas.drawX, canvas.drawY);
            this.contextProgressClone.save();
        }
    }, {
        key: 'destroy',
        value: function destroy() {
            this.contextValueClone = null;
            this.elementValueClone = null;
            this.contextProgressClone = null;
            this.elementProgressClone = null;
            _get(CanvasDigitalGauge.prototype.__proto__ || Object.getPrototypeOf(CanvasDigitalGauge.prototype), 'destroy', this).call(this);
        }
    }, {
        key: 'update',
        value: function update(options) {
            this.canvas.onRedraw = null;
            var result = _get(CanvasDigitalGauge.prototype.__proto__ || Object.getPrototypeOf(CanvasDigitalGauge.prototype), 'update', this).call(this, options);
            this.initValueClone();
            this.canvas.onRedraw = this.draw.bind(this);
            this.draw();
            return result;
        }
    }, {
        key: 'draw',
        value: function draw() {
            try {

                var canvas = this.canvas;

                if (!canvas.drawWidth || !canvas.drawHeight) {
                    return this;
                }

                var _ref = [-canvas.drawX, -canvas.drawY, canvas.drawWidth, canvas.drawHeight],
                    x = _ref[0],
                    y = _ref[1],
                    w = _ref[2],
                    h = _ref[3];

                var options = this.options;
                if (!canvas.elementClone.initialized) {
                    var context = canvas.contextClone;

                    // clear the cache
                    context.clearRect(x, y, w, h);
                    context.save();

                    canvas.context.barDimensions = barDimensions(context, options, x, y, w, h);
                    this.contextValueClone.barDimensions = canvas.context.barDimensions;
                    this.contextProgressClone.barDimensions = canvas.context.barDimensions;

                    drawBackground(context, options);

                    drawDigitalTitle(context, options);

                    if (!options.showTimestamp) {
                        drawDigitalLabel(context, options);
                    }

                    drawDigitalMinMax(context, options);

                    canvas.elementClone.initialized = true;
                }

                var valueChanged = false;
                if (!this.elementValueClone.initialized || angular.isDefined(this._value) && this.elementValueClone.renderedValue !== this._value || options.showTimestamp && this.elementValueClone.renderedTimestamp !== this.timestamp) {
                    if (angular.isDefined(this._value)) {
                        this.elementValueClone.renderedValue = this._value;
                    }
                    if (angular.isUndefined(this.elementValueClone.renderedValue)) {
                        this.elementValueClone.renderedValue = this.value;
                    }
                    var _context = this.contextValueClone;
                    // clear the cache
                    _context.clearRect(x, y, w, h);
                    _context.save();

                    _context.drawImage(canvas.elementClone, x, y, w, h);
                    _context.save();

                    drawDigitalValue(_context, options, this.elementValueClone.renderedValue);

                    if (options.showTimestamp) {
                        drawDigitalLabel(_context, options);
                        this.elementValueClone.renderedTimestamp = this.timestamp;
                    }

                    this.elementValueClone.initialized = true;

                    valueChanged = true;
                }

                var progress = (_canvasGauges2.default.drawings.normalizedValue(options).normal - options.minValue) / (options.maxValue - options.minValue);

                var fixedProgress = progress.toFixed(3);

                if (!this.elementProgressClone.initialized || this.elementProgressClone.renderedProgress !== fixedProgress || valueChanged) {
                    var _context2 = this.contextProgressClone;
                    // clear the cache
                    _context2.clearRect(x, y, w, h);
                    _context2.save();

                    _context2.drawImage(this.elementValueClone, x, y, w, h);
                    _context2.save();

                    if (Number(fixedProgress) > 0) {
                        drawProgress(_context2, options, progress);
                    }

                    this.elementProgressClone.initialized = true;
                    this.elementProgressClone.renderedProgress = fixedProgress;
                }

                this.canvas.commit();

                // clear the canvas
                canvas.context.clearRect(x, y, w, h);
                canvas.context.save();

                canvas.context.drawImage(this.elementProgressClone, x, y, w, h);
                canvas.context.save();

                _get(CanvasDigitalGauge.prototype.__proto__ || Object.getPrototypeOf(CanvasDigitalGauge.prototype), 'draw', this).call(this);
            } catch (err) {
                _canvasGauges2.default.drawings.verifyError(err);
            }
            return this;
        }
    }, {
        key: 'getValueColor',
        value: function getValueColor() {
            if (this.contextProgressClone) {
                var color = this.contextProgressClone.currentColor;
                if (!color) {
                    if (this.options.neonGlowBrightness) {
                        color = getProgressColor(0, this.options.neonColorsRange);
                    } else {
                        color = getProgressColor(0, this.options.colorsRange);
                    }
                }
                return color;
            } else {
                return '#000';
            }
        }
    }, {
        key: 'timestamp',
        set: function set(timestamp) {
            this.options.timestamp = timestamp;
            this.draw();
        },
        get: function get() {
            return this.options.timestamp;
        }
    }], [{
        key: 'configure',
        value: function configure(options) {

            if (options.value > options.maxValue) {
                options.value = options.maxValue;
            }

            if (options.value < options.minValue) {
                options.value = options.minValue;
            }

            if (options.gaugeType === 'donut') {
                if (!options.donutStartAngle) {
                    options.donutStartAngle = 1.5 * Math.PI;
                }
                if (!options.donutEndAngle) {
                    options.donutEndAngle = options.donutStartAngle + 2 * Math.PI;
                }
            }

            var colorsCount = options.levelColors.length;
            var inc = colorsCount > 1 ? 1 / (colorsCount - 1) : 1;
            options.colorsRange = [];
            if (options.neonGlowBrightness) {
                options.neonColorsRange = [];
            }
            for (var i = 0; i < options.levelColors.length; i++) {
                var percentage = inc * i;
                var tColor = (0, _tinycolor2.default)(options.levelColors[i]);
                options.colorsRange[i] = {
                    pct: percentage,
                    color: tColor.toRgb(),
                    rgbString: tColor.toRgbString()
                };
                if (options.neonGlowBrightness) {
                    tColor = (0, _tinycolor2.default)(options.levelColors[i]).brighten(options.neonGlowBrightness);
                    options.neonColorsRange[i] = {
                        pct: percentage,
                        color: tColor.toRgb(),
                        rgbString: tColor.toRgbString()
                    };
                }
            }

            if (options.neonGlowBrightness) {
                options.neonColorTitle = (0, _tinycolor2.default)(options.colorTitle).brighten(options.neonGlowBrightness).toHexString();
                options.neonColorLabel = (0, _tinycolor2.default)(options.colorLabel).brighten(options.neonGlowBrightness).toHexString();
                options.neonColorValue = (0, _tinycolor2.default)(options.colorValue).brighten(options.neonGlowBrightness).toHexString();
                options.neonColorMinMax = (0, _tinycolor2.default)(options.colorMinMax).brighten(options.neonGlowBrightness).toHexString();
            }

            return _canvasGauges2.default.BaseGauge.configure(options);
        }
    }]);

    return CanvasDigitalGauge;
}(_canvasGauges2.default.BaseGauge);

/* eslint-disable angular/document-service */
/* eslint-disable no-undef */


exports.default = CanvasDigitalGauge;
function determineFontHeight(options, target, baseSize) {
    var fontStyleStr = 'font-style:' + options['font' + target + 'Style'] + ';font-weight:' + options['font' + target + 'Weight'] + ';font-size:' + options['font' + target + 'Size'] * baseSize + 'px;font-family:' + options['font' + target];
    var result = CanvasDigitalGauge.heightCache[fontStyleStr];
    if (!result) {
        var fontStyle = {
            fontFamily: options['font' + target],
            fontSize: options['font' + target + 'Size'] * baseSize + 'px',
            fontWeight: options['font' + target + 'Weight'],
            fontStyle: options['font' + target + 'Style']
        };

        var text = (0, _jquery2.default)('<span>Hg</span>').css(fontStyle);
        var block = (0, _jquery2.default)('<div style="display: inline-block; width: 1px; height: 0px;"></div>');

        var div = (0, _jquery2.default)('<div></div>');
        div.append(text, block);

        var body = (0, _jquery2.default)('body');
        body.append(div);

        try {
            result = {};
            block.css({ verticalAlign: 'baseline' });
            result.ascent = block.offset().top - text.offset().top;
            block.css({ verticalAlign: 'bottom' });
            result.height = block.offset().top - text.offset().top;
            result.descent = result.height - result.ascent;
        } finally {
            div.remove();
        }
        CanvasDigitalGauge.heightCache[fontStyleStr] = result;
    }
    return result;
}

/* eslint-enable angular/document-service */
/* eslint-enable no-undef */

function barDimensions(context, options, x, y, w, h) {

    context.barDimensions = {
        baseX: x,
        baseY: y,
        width: w,
        height: h
    };

    var bd = context.barDimensions;

    var aspect = 1;

    if (options.gaugeType === 'horizontalBar') {
        aspect = options.title === '' ? 2.5 : 2;
    } else if (options.gaugeType === 'verticalBar') {
        aspect = options.hideMinMax ? 0.35 : 0.5;
    } else if (options.gaugeType === 'arc') {
        aspect = 1.5;
    }

    var currentAspect = w / h;
    if (currentAspect > aspect) {
        bd.width = h * aspect;
        bd.height = h;
    } else {
        bd.width = w;
        bd.height = w / aspect;
    }

    bd.origBaseX = bd.baseX;
    bd.origBaseY = bd.baseY;
    bd.baseX += (w - bd.width) / 2;
    bd.baseY += (h - bd.height) / 2;

    if (options.gaugeType === 'donut') {
        bd.fontSizeFactor = Math.max(bd.width, bd.height) / 125;
    } else if (options.gaugeType === 'verticalBar' || options.gaugeType === 'arc' && options.title === '') {
        bd.fontSizeFactor = Math.max(bd.width, bd.height) / 150;
    } else {
        bd.fontSizeFactor = Math.max(bd.width, bd.height) / 200;
    }

    var gws = options.gaugeWidthScale;

    if (options.neonGlowBrightness) {
        options.fontTitleHeight = determineFontHeight(options, 'Title', bd.fontSizeFactor);
        options.fontLabelHeight = determineFontHeight(options, 'Label', bd.fontSizeFactor);
        options.fontValueHeight = determineFontHeight(options, 'Value', bd.fontSizeFactor);
        options.fontMinMaxHeight = determineFontHeight(options, 'MinMax', bd.fontSizeFactor);
    }

    if (options.gaugeType === 'donut') {
        bd.Ro = bd.width / 2 - bd.width / 20;
        bd.Cy = bd.baseY + bd.height / 2;
        if (options.title && options.title.length > 0) {
            var titleOffset = determineFontHeight(options, 'Title', bd.fontSizeFactor).height;
            titleOffset += bd.fontSizeFactor * 2;
            bd.titleY = bd.baseY + titleOffset;
            titleOffset += bd.fontSizeFactor * 2;
            bd.Cy += titleOffset / 2;
            bd.Ro -= titleOffset / 2;
        }
        bd.Ri = bd.Ro - bd.width / 6.666666666666667 * gws * 1.2;
        bd.Cx = bd.baseX + bd.width / 2;
    } else if (options.gaugeType === 'arc') {
        if (options.title && options.title.length > 0) {
            bd.Ro = bd.width / 2 - bd.width / 7;
            bd.Ri = bd.Ro - bd.width / 6.666666666666667 * gws;
        } else {
            bd.Ro = bd.width / 2 - bd.fontSizeFactor * 4;
            bd.Ri = bd.Ro - bd.width / 6.666666666666667 * gws * 1.2;
        }
        bd.Cx = bd.baseX + bd.width / 2;
        bd.Cy = bd.baseY + bd.height / 1.25;
    } else if (options.gaugeType === 'verticalBar') {
        bd.Ro = bd.width / 2 - bd.width / 10;
        bd.Ri = bd.Ro - bd.width / 6.666666666666667 * gws * (options.hideMinMax ? 4 : 2.5);
    } else {
        //horizontalBar
        bd.Ro = bd.width / 2 - bd.width / 10;
        bd.Ri = bd.Ro - bd.width / 6.666666666666667 * gws;
    }

    bd.strokeWidth = bd.Ro - bd.Ri;
    bd.Rm = bd.Ri + bd.strokeWidth * 0.5;

    bd.fontValueBaseline = 'alphabetic';
    bd.fontMinMaxBaseline = 'alphabetic';
    bd.fontMinMaxAlign = 'center';

    if (options.gaugeType === 'donut') {
        bd.fontValueBaseline = 'middle';
        if (options.label && options.label.length > 0) {
            var valueHeight = determineFontHeight(options, 'Value', bd.fontSizeFactor).height;
            var labelHeight = determineFontHeight(options, 'Label', bd.fontSizeFactor).height;
            var total = valueHeight + labelHeight;
            bd.labelY = bd.Cy + total / 2;
            bd.valueY = bd.Cy - total / 2 + valueHeight / 2;
        } else {
            bd.valueY = bd.Cy;
        }
    } else if (options.gaugeType === 'arc') {
        bd.titleY = bd.Cy - bd.Ro - 12 * bd.fontSizeFactor;
        bd.valueY = bd.Cy;
        bd.labelY = bd.Cy + (8 + options.fontLabelSize) * bd.fontSizeFactor;
        bd.minY = bd.maxY = bd.labelY;
        if (options.roundedLineCap) {
            bd.minY += bd.strokeWidth / 2;
            bd.maxY += bd.strokeWidth / 2;
        }
        bd.minX = bd.Cx - bd.Rm;
        bd.maxX = bd.Cx + bd.Rm;
    } else if (options.gaugeType === 'horizontalBar') {
        bd.titleY = bd.baseY + 4 * bd.fontSizeFactor + (options.title === '' ? 0 : options.fontTitleSize * bd.fontSizeFactor);
        bd.titleBottom = bd.titleY + (options.title === '' ? 0 : 4) * bd.fontSizeFactor;

        bd.valueY = bd.titleBottom + (options.hideValue ? 0 : options.fontValueSize * bd.fontSizeFactor);

        bd.barTop = bd.valueY + 8 * bd.fontSizeFactor;
        bd.barBottom = bd.barTop + bd.strokeWidth;

        if (options.hideMinMax && options.label === '') {
            bd.labelY = bd.barBottom;
            bd.barLeft = bd.origBaseX + options.fontMinMaxSize / 3 * bd.fontSizeFactor;
            bd.barRight = bd.origBaseX + w + /*bd.width*/-options.fontMinMaxSize / 3 * bd.fontSizeFactor;
        } else {
            context.font = _canvasGauges2.default.drawings.font(options, 'MinMax', bd.fontSizeFactor);
            var minTextWidth = context.measureText(options.minValue + '').width;
            var maxTextWidth = context.measureText(options.maxValue + '').width;
            var maxW = Math.max(minTextWidth, maxTextWidth);
            bd.minX = bd.origBaseX + maxW / 2 + options.fontMinMaxSize / 3 * bd.fontSizeFactor;
            bd.maxX = bd.origBaseX + w + /*bd.width*/-maxW / 2 - options.fontMinMaxSize / 3 * bd.fontSizeFactor;
            bd.barLeft = bd.minX;
            bd.barRight = bd.maxX;
            bd.labelY = bd.barBottom + (8 + options.fontLabelSize) * bd.fontSizeFactor;
            bd.minY = bd.maxY = bd.labelY;
        }
    } else if (options.gaugeType === 'verticalBar') {
        bd.titleY = bd.baseY + ((options.title === '' ? 0 : options.fontTitleSize) + 8) * bd.fontSizeFactor;
        bd.titleBottom = bd.titleY + (options.title === '' ? 0 : 4) * bd.fontSizeFactor;

        bd.valueY = bd.titleBottom + (options.hideValue ? 0 : options.fontValueSize * bd.fontSizeFactor);
        bd.barTop = bd.valueY + 8 * bd.fontSizeFactor;

        bd.labelY = bd.baseY + bd.height - 16;
        if (options.label === '') {
            bd.barBottom = bd.labelY;
        } else {
            bd.barBottom = bd.labelY - (8 + options.fontLabelSize) * bd.fontSizeFactor;
        }
        bd.minX = bd.maxX = bd.baseX + bd.width / 2 + bd.strokeWidth / 2 + options.fontMinMaxSize / 3 * bd.fontSizeFactor;
        bd.minY = bd.barBottom;
        bd.maxY = bd.barTop;
        bd.fontMinMaxBaseline = 'middle';
        bd.fontMinMaxAlign = 'left';
    }

    if (options.dashThickness) {
        var circumference;
        if (options.gaugeType === 'donut') {
            circumference = Math.PI * bd.Rm * 2;
        } else if (options.gaugeType === 'arc') {
            circumference = Math.PI * bd.Rm;
        } else if (options.gaugeType === 'horizontalBar') {
            circumference = bd.barRight - bd.barLeft;
        } else if (options.gaugeType === 'verticalBar') {
            circumference = bd.barBottom - bd.barTop;
        }
        var dashCount = Math.floor(circumference / (options.dashThickness * bd.fontSizeFactor));
        if (options.gaugeType === 'donut') {
            dashCount = (dashCount | 1) - 1;
        } else {
            dashCount = dashCount - 1 | 1;
        }
        bd.dashLength = Math.ceil(circumference / dashCount);
    }

    return bd;
}

function drawBackground(context, options) {
    var _context$barDimension = context.barDimensions,
        barLeft = _context$barDimension.barLeft,
        barRight = _context$barDimension.barRight,
        barTop = _context$barDimension.barTop,
        barBottom = _context$barDimension.barBottom,
        width = _context$barDimension.width,
        baseX = _context$barDimension.baseX,
        strokeWidth = _context$barDimension.strokeWidth;

    if (context.barDimensions.dashLength) {
        context.setLineDash([context.barDimensions.dashLength]);
    }
    context.beginPath();
    context.strokeStyle = options.gaugeColor;
    context.lineWidth = strokeWidth;
    if (options.roundedLineCap) {
        context.lineCap = 'round';
    }
    if (options.gaugeType === 'donut') {
        context.arc(context.barDimensions.Cx, context.barDimensions.Cy, context.barDimensions.Rm, options.donutStartAngle, options.donutEndAngle);
        context.stroke();
    } else if (options.gaugeType === 'arc') {
        context.arc(context.barDimensions.Cx, context.barDimensions.Cy, context.barDimensions.Rm, Math.PI, 2 * Math.PI);
        context.stroke();
    } else if (options.gaugeType === 'horizontalBar') {
        context.moveTo(barLeft, barTop + strokeWidth / 2);
        context.lineTo(barRight, barTop + strokeWidth / 2);
        context.stroke();
    } else if (options.gaugeType === 'verticalBar') {
        context.moveTo(baseX + width / 2, barBottom);
        context.lineTo(baseX + width / 2, barTop);
        context.stroke();
    }
}

function drawText(context, options, target, text, textX, textY) {
    context.fillStyle = options[(options.neonGlowBrightness ? 'neonColor' : 'color') + target];
    context.fillText(text, textX, textY);
}

function drawDigitalTitle(context, options) {
    if (!options.title) return;

    var _context$barDimension2 = context.barDimensions,
        titleY = _context$barDimension2.titleY,
        width = _context$barDimension2.width,
        baseX = _context$barDimension2.baseX,
        fontSizeFactor = _context$barDimension2.fontSizeFactor;


    var textX = round(baseX + width / 2);
    var textY = titleY;

    context.save();
    context.textAlign = 'center';
    context.font = _canvasGauges2.default.drawings.font(options, 'Title', fontSizeFactor);
    context.lineWidth = 0;
    drawText(context, options, 'Title', options.title.toUpperCase(), textX, textY);
}

function drawDigitalLabel(context, options) {
    if (!options.label || options.label === '') return;

    var _context$barDimension3 = context.barDimensions,
        labelY = _context$barDimension3.labelY,
        baseX = _context$barDimension3.baseX,
        width = _context$barDimension3.width,
        fontSizeFactor = _context$barDimension3.fontSizeFactor;


    var textX = round(baseX + width / 2);
    var textY = labelY;

    context.save();
    context.textAlign = 'center';
    context.font = _canvasGauges2.default.drawings.font(options, 'Label', fontSizeFactor);
    context.lineWidth = 0;
    drawText(context, options, 'Label', options.label.toUpperCase(), textX, textY);
}

function drawDigitalMinMax(context, options) {
    if (options.hideMinMax || options.gaugeType === 'donut') return;

    var _context$barDimension4 = context.barDimensions,
        minY = _context$barDimension4.minY,
        maxY = _context$barDimension4.maxY,
        minX = _context$barDimension4.minX,
        maxX = _context$barDimension4.maxX,
        fontSizeFactor = _context$barDimension4.fontSizeFactor,
        fontMinMaxAlign = _context$barDimension4.fontMinMaxAlign,
        fontMinMaxBaseline = _context$barDimension4.fontMinMaxBaseline;


    context.save();
    context.textAlign = fontMinMaxAlign;
    context.textBaseline = fontMinMaxBaseline;
    context.font = _canvasGauges2.default.drawings.font(options, 'MinMax', fontSizeFactor);
    context.lineWidth = 0;
    drawText(context, options, 'MinMax', options.minValue + '', minX, minY);
    drawText(context, options, 'MinMax', options.maxValue + '', maxX, maxY);
}

function padValue(val, options) {
    var dec = options.valueDec;
    var strVal = void 0,
        n = void 0;

    val = parseFloat(val);
    n = val < 0;
    val = Math.abs(val);

    if (dec > 0) {
        strVal = val.toFixed(dec).toString();
    } else {
        strVal = round(val).toString();
    }
    strVal = (n ? '-' : '') + strVal;
    return strVal;
}

function drawDigitalValue(context, options, value) {
    if (options.hideValue) return;

    var _context$barDimension5 = context.barDimensions,
        valueY = _context$barDimension5.valueY,
        baseX = _context$barDimension5.baseX,
        width = _context$barDimension5.width,
        fontSizeFactor = _context$barDimension5.fontSizeFactor,
        fontValueBaseline = _context$barDimension5.fontValueBaseline;


    var textX = round(baseX + width / 2);
    var textY = valueY;

    var text = options.valueText || padValue(value, options);
    text += options.symbol;

    context.save();
    context.textAlign = 'center';
    context.textBaseline = fontValueBaseline;
    context.font = _canvasGauges2.default.drawings.font(options, 'Value', fontSizeFactor);
    context.lineWidth = 0;
    drawText(context, options, 'Value', text, textX, textY);
}

function getProgressColor(progress, colorsRange) {

    var lower, upper, range, rangePct, pctLower, pctUpper, color;

    if (progress === 0 || colorsRange.length === 1) {
        return colorsRange[0].rgbString;
    }

    for (var j = 0; j < colorsRange.length; j++) {
        if (progress <= colorsRange[j].pct) {
            lower = colorsRange[j - 1];
            upper = colorsRange[j];
            range = upper.pct - lower.pct;
            rangePct = (progress - lower.pct) / range;
            pctLower = 1 - rangePct;
            pctUpper = rangePct;
            color = (0, _tinycolor2.default)({
                r: Math.floor(lower.color.r * pctLower + upper.color.r * pctUpper),
                g: Math.floor(lower.color.g * pctLower + upper.color.g * pctUpper),
                b: Math.floor(lower.color.b * pctLower + upper.color.b * pctUpper)
            });
            return color.toRgbString();
        }
    }
}

function drawArcGlow(context, Cx, Cy, Ri, Rm, Ro, color, progress, isDonut, donutStartAngle, donutEndAngle) {
    context.setLineDash([]);
    var strokeWidth = Ro - Ri;
    var blur = 0.55;
    var edge = strokeWidth * blur;
    context.lineWidth = strokeWidth + edge;
    var stop = blur / (2 * blur + 2);
    var glowGradient = context.createRadialGradient(Cx, Cy, Ri - edge / 2, Cx, Cy, Ro + edge / 2);
    var color1 = (0, _tinycolor2.default)(color).setAlpha(0.5).toRgbString();
    var color2 = (0, _tinycolor2.default)(color).setAlpha(0).toRgbString();
    glowGradient.addColorStop(0, color2);
    glowGradient.addColorStop(stop, color1);
    glowGradient.addColorStop(1.0 - stop, color1);
    glowGradient.addColorStop(1, color2);
    context.strokeStyle = glowGradient;
    context.beginPath();
    var e = 0.01 * Math.PI;
    if (isDonut) {
        context.arc(Cx, Cy, Rm, donutStartAngle - e, donutStartAngle + (donutEndAngle - donutStartAngle) * progress + e);
    } else {
        context.arc(Cx, Cy, Rm, Math.PI - e, Math.PI + Math.PI * progress + e);
    }
    context.stroke();
}

function drawBarGlow(context, startX, startY, endX, endY, color, strokeWidth, isVertical) {
    context.setLineDash([]);
    var blur = 0.55;
    var edge = strokeWidth * blur;
    context.lineWidth = strokeWidth + edge;
    var stop = blur / (2 * blur + 2);
    var gradientStartX = isVertical ? startX - context.lineWidth / 2 : 0;
    var gradientStartY = isVertical ? 0 : startY - context.lineWidth / 2;
    var gradientStopX = isVertical ? startX + context.lineWidth / 2 : 0;
    var gradientStopY = isVertical ? 0 : startY + context.lineWidth / 2;

    var glowGradient = context.createLinearGradient(gradientStartX, gradientStartY, gradientStopX, gradientStopY);
    var color1 = (0, _tinycolor2.default)(color).setAlpha(0.5).toRgbString();
    var color2 = (0, _tinycolor2.default)(color).setAlpha(0).toRgbString();
    glowGradient.addColorStop(0, color2);
    glowGradient.addColorStop(stop, color1);
    glowGradient.addColorStop(1.0 - stop, color1);
    glowGradient.addColorStop(1, color2);
    context.strokeStyle = glowGradient;
    var dx = isVertical ? 0 : 0.05 * context.lineWidth;
    var dy = isVertical ? 0.05 * context.lineWidth : 0;
    context.beginPath();
    context.moveTo(startX - dx, startY + dy);
    context.lineTo(endX + dx, endY - dy);
    context.stroke();
}

function drawProgress(context, options, progress) {
    var neonColor;
    if (options.neonGlowBrightness) {
        context.currentColor = neonColor = getProgressColor(progress, options.neonColorsRange);
    } else {
        context.currentColor = context.strokeStyle = getProgressColor(progress, options.colorsRange);
    }

    var _context$barDimension6 = context.barDimensions,
        barLeft = _context$barDimension6.barLeft,
        barRight = _context$barDimension6.barRight,
        barTop = _context$barDimension6.barTop,
        baseX = _context$barDimension6.baseX,
        width = _context$barDimension6.width,
        barBottom = _context$barDimension6.barBottom,
        Cx = _context$barDimension6.Cx,
        Cy = _context$barDimension6.Cy,
        Rm = _context$barDimension6.Rm,
        Ro = _context$barDimension6.Ro,
        Ri = _context$barDimension6.Ri,
        strokeWidth = _context$barDimension6.strokeWidth;


    if (context.barDimensions.dashLength) {
        context.setLineDash([context.barDimensions.dashLength]);
    }
    context.lineWidth = strokeWidth;
    if (options.roundedLineCap) {
        context.lineCap = 'round';
    } else {
        context.lineCap = 'butt';
    }
    if (options.gaugeType === 'donut') {
        if (options.neonGlowBrightness) {
            context.strokeStyle = neonColor;
        }
        context.beginPath();
        context.arc(Cx, Cy, Rm, options.donutStartAngle, options.donutStartAngle + (options.donutEndAngle - options.donutStartAngle) * progress);
        context.stroke();
        if (options.neonGlowBrightness && !options.isMobile) {
            drawArcGlow(context, Cx, Cy, Ri, Rm, Ro, neonColor, progress, true, options.donutStartAngle, options.donutEndAngle);
        }
    } else if (options.gaugeType === 'arc') {
        if (options.neonGlowBrightness) {
            context.strokeStyle = neonColor;
        }
        context.beginPath();
        context.arc(Cx, Cy, Rm, Math.PI, Math.PI + Math.PI * progress);
        context.stroke();
        if (options.neonGlowBrightness && !options.isMobile) {
            drawArcGlow(context, Cx, Cy, Ri, Rm, Ro, neonColor, progress, false);
        }
    } else if (options.gaugeType === 'horizontalBar') {
        if (options.neonGlowBrightness) {
            context.strokeStyle = neonColor;
        }
        context.beginPath();
        context.moveTo(barLeft, barTop + strokeWidth / 2);
        context.lineTo(barLeft + (barRight - barLeft) * progress, barTop + strokeWidth / 2);
        context.stroke();
        if (options.neonGlowBrightness && !options.isMobile) {
            drawBarGlow(context, barLeft, barTop + strokeWidth / 2, barLeft + (barRight - barLeft) * progress, barTop + strokeWidth / 2, neonColor, strokeWidth, false);
        }
    } else if (options.gaugeType === 'verticalBar') {
        if (options.neonGlowBrightness) {
            context.strokeStyle = neonColor;
        }
        context.beginPath();
        context.moveTo(baseX + width / 2, barBottom);
        context.lineTo(baseX + width / 2, barBottom - (barBottom - barTop) * progress);
        context.stroke();
        if (options.neonGlowBrightness && !options.isMobile) {
            drawBarGlow(context, baseX + width / 2, barBottom, baseX + width / 2, barBottom - (barBottom - barTop) * progress, neonColor, strokeWidth, true);
        }
    }
}

CanvasDigitalGauge.heightCache = [];

_canvasGauges2.default.BaseGauge.initialize('CanvasDigitalGauge', defaultDigitalGaugeOptions);

/* eslint-enable angular/angularelement */


// WEBPACK FOOTER //
// ./src/app/widget/lib/CanvasDigitalGauge.js